import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPageTableRowHeader: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: 56,
    overflow: "hidden",
    whiteSpace: "nowrap",
    fontFamily: "SuisseIntlMedium",
    padding: "10px 20px 0 20px",
    color: "initial"
  }
}));
